<ng-container *transloco="let t">
  <ng-container *ngIf="showMaterialData$ | withLoader | async as showMaterialData">
    <ng-container
      *ngIf="{ products: diagnosticProducts$ | withLoader | async, materials: diagnosticMaterials$ | withLoader | async } as vm"
    >
      <app-material *ngIf="showMaterialData === SortType.DIAGNOSTIC" [products]="vm.products" [materials]="vm.materials"></app-material>
    </ng-container>

    <ng-container
      *ngIf="{ products: educationalProducts$ | withLoader | async, materials: educationalMaterials$ | withLoader | async } as vm"
    >
      <app-material *ngIf="showMaterialData === SortType.EDUCATIONAL" [products]="vm.products" [materials]="vm.materials"></app-material>
    </ng-container>
  </ng-container>
</ng-container>
